import { useEffect, useState } from 'react'
import { LockActivity, UnlockActivity } from '../services/AnnualPlanService'

type ModalState = 'add' | 'delete' | 'track' | 'update' | 'clearTrack' | 'none'

interface UseModalStateType<T> {
  currentItem?: T
  modalState: ModalState
  setModalState: (state: ModalState) => void
  startModal: (state: ModalState, item?: T) => Promise<void>
  handleCloseModal: () => Promise<void>
}

export const useModalState = <T extends { id: number, isUpdate: boolean }>(lockName: string): UseModalStateType<T> => {
  const [currentItem, setCurrentItem] = useState<T | undefined>(undefined)
  const [modalState, setModalState] = useState<ModalState>('none')

  useEffect(() => {
    if (modalState === 'none') {
      if (currentItem == null) return
      setCurrentItem(undefined)
    }
  }, [modalState])

  const handleCloseModal = async (): Promise<void> => {
    if (currentItem != null) {
      await UnlockActivity(currentItem.id, lockName, currentItem.isUpdate)
    }
    setModalState('none')
  }

  const startModal = async (state: ModalState, item?: T): Promise<void> => {
    if (item != null) {
      await LockActivity(item.id, lockName, item.isUpdate)
      setCurrentItem(item)
    }
    setModalState(state)
  }

  return { modalState, startModal, currentItem, handleCloseModal, setModalState }
}
